import api from "@/lib/api";

// Géocodage inverse partagé (adresse + ville). Cache mémoire par coordonnée arrondie (3 décimales,
// identique au cache serveur `_geocode_cache`). Réutilise l'endpoint existant /api/geocode/reverse ;
// aucune nouvelle intégration, aucun envoi massif (coordonnées dédupliquées + requêtes en vol mutualisées).
const _cache = {};        // "lat,lon" -> adresse ("" si indisponible)
const _inflight = {};     // "lat,lon" -> Promise

export const geoKey = (lat, lon) => `${Number(lat).toFixed(3)},${Number(lon).toFixed(3)}`;

export const coordsText = (lat, lon) =>
  (lat != null && lon != null) ? `${Number(lat).toFixed(5)}, ${Number(lon).toFixed(5)}` : "—";

export function cachedAddress(lat, lon) {
  if (lat == null || lon == null) return undefined;
  return _cache[geoKey(lat, lon)];
}

export async function reverseGeocode(lat, lon) {
  if (lat == null || lon == null) return "";
  const key = geoKey(lat, lon);
  if (key in _cache) return _cache[key];
  if (_inflight[key]) return _inflight[key];
  _inflight[key] = (async () => {
    try {
      const r = await api.get(`/geocode/reverse?lat=${lat}&lon=${lon}`, { timeout: 8000 });
      const addr = r.data?.address || "";
      _cache[key] = addr;           // succès (adresse ou « indisponible ») : mis en cache
      return addr;
    } catch {
      return "";                    // échec réseau/timeout : NON caché → nouvelle tentative au prochain montage
    } finally {
      delete _inflight[key];
    }
  })();
  return _inflight[key];
}
